import React from 'react';
import { getBunsHistory, getRewardRules } from '../network/bunsApi';
import './BunsHistory.css';

class BunsHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            history: [],
            rules: {},
            loading: true,
            page: 1,
            hasMore: true,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const userInfo = localStorage.getItem('initUser');
        if (!userInfo) return;
        const userJson = JSON.parse(userInfo);
        const userId = userJson.user_id;

        try {
            const [historyRes, rulesRes] = await Promise.all([
                getBunsHistory(userId, 1, 50),
                getRewardRules(),
            ]);

            const rulesMap = {};
            if (rulesRes.success && rulesRes.data) {
                rulesRes.data.forEach(r => {
                    rulesMap[r.reward_type] = r;
                });
            }

            this.setState({
                history: historyRes.success ? historyRes.data : [],
                rules: rulesMap,
                loading: false,
                hasMore: historyRes.success && historyRes.data.length >= 50,
            });
        } catch (error) {
            console.error('Failed to load BUNS history:', error);
            this.setState({ loading: false });
        }
    };

    loadMore = async () => {
        const { page } = this.state;
        const userInfo = localStorage.getItem('initUser');
        const userJson = JSON.parse(userInfo);
        const userId = userJson.user_id;

        try {
            const historyRes = await getBunsHistory(userId, page + 1, 50);
            if (historyRes.success && historyRes.data) {
                this.setState({
                    history: [...this.state.history, ...historyRes.data],
                    page: page + 1,
                    hasMore: historyRes.data.length >= 50,
                });
            } else {
                this.setState({ hasMore: false });
            }
        } catch (error) {
            console.error('Failed to load more:', error);
        }
    };

    getRuleInfo = (rewardType) => {
        const { rules } = this.state;
        const rule = rules[rewardType];
        if (!rule) return { name: rewardType, icon: '✨' };

        const iconMap = {
            first_register: '🎉',
            extra_question: '📝',
            daily_login: '🥟',
            watched_ad: '📺',
            reply_match: '💬',
            referral_bonus: '👥',
            weekly_quiz: '🧠',
        };
        return { name: rule.reward_name, icon: iconMap[rewardType] || '✨' };
    };

    formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const hour = d.getHours().toString().padStart(2, '0');
        const min = d.getMinutes().toString().padStart(2, '0');
        return `${month}-${day} ${hour}:${min}`;
    };

    render() {
        const { history, loading, hasMore } = this.state;

        return (
            <div className="bunsHistoryWrap">
                <p className="bunsHistoryTitle">Reward History</p>
                {loading ? (
                    <div className="bunsHistoryLoading">
                        <div className="bunsSpinner"></div>
                        <p>Loading...</p>
                    </div>
                ) : history.length === 0 ? (
                    <div className="bunsHistoryEmpty">
                        <span className="bunsEmptyIcon">📭</span>
                        <p>No BUNS earned yet</p>
                        <p className="bunsEmptySub">Complete daily tasks to earn rewards!</p>
                    </div>
                ) : (
                    <div className="bunsHistoryList">
                        {history.map((item) => {
                            const { name, icon } = this.getRuleInfo(item.reward_type);
                            return (
                                <div key={item.id} className="bunsHistoryItem">
                                    <div className="bunsHistoryLeft">
                                        <span className="bunsHistoryIcon">{icon}</span>
                                        <div className="bunsHistoryInfo">
                                            <p className="bunsHistoryName">{name}</p>
                                            {item.source_detail && (
                                                <p className="bunsHistorySource">{item.source_detail}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="bunsHistoryRight">
                                        <span className="bunsHistoryAmount">+{item.buns_amount}</span>
                                        <span className="bunsHistoryTime">{this.formatDate(item.create_time)}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
                {hasMore && history.length > 0 && (
                    <button className="bunsLoadMoreBtn" onClick={this.loadMore}>
                        Load More
                    </button>
                )}
            </div>
        );
    }
}

export default BunsHistory;
